import { config } from '@/store'

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function log(...args) {
  if (config.debug) {
    console.log(...args)
  }
}

export function prettyDate(ISOdate) {
  const date = new Date(ISOdate)
  return date.getUTCDate() + ' ' + monthNames[date.getUTCMonth()] + ' ' + date.getUTCFullYear()
}

export function prettyDateTime(ISOdate) {
  const date = new Date(ISOdate)
  if (date.toString() === 'Invalid Date') {
    return ISOdate
  }
  const hours = `${date.getUTCHours()}`.padStart(2, 0)
  const minutes = `${date.getUTCMinutes()}`.padStart(2, 0)
  return hours + ':' + minutes + ', ' + date.getUTCDate() + ' ' + monthNames[date.getUTCMonth()] + ' ' + date.getUTCFullYear()
}

export function prettyNumber(number) {
  var unit = ''
  if (isNaN(number) || !isFinite(number)) {
    return 'N/A'
  }
  var value = Math.abs(number)

  if (value < 1000) {
    unit = ''
  } else if (value < 1000000) {
    unit = 'K'
    value = value / 1000
  } else if (value < 1000000000) {
    unit = 'M'
    value = value / 1000000
  }

  var maxDecimals = 0
  if (value < 10 && unit !== '') {
    maxDecimals = 1
  }
  return value.toFixed(maxDecimals) + unit
}

export function prettyDuration(s) {
  const m = Math.round(s / 60)
  const mr = s % 60
  const h = Math.round(m / 60)
  const hr = m % 60
  const d = Math.round(h / 24)
  const dr = h % 24
  return (!dr && d === 1) || d > 1 ? `${d}d` : (!hr && h === 1) || h > 1 ? `${h}h` : (!mr && m === 1) || m > 1 ? `${m}m` : s > 1 ? `${s}s` : 0
}

export function getCountry(language) {
  return language
    .replace(/ar-\w\w/i, 'ar')
    .replace(/en-\w\w/i, 'gb')
    .replace(/es-\w\w/i, 'es')
    .replace(/fr-\w\w/i, 'fr')
    .replace(/pt-\w\w/i, 'pt')
    .replace(/sv-\w\w/i, 'se')
    .replace('da', 'dk')
    .replace('en', 'gb')
    .replace('ja', 'jp')
    .replace('sv', 'se')
    .replace('ko', 'kr')
}

export function keyBy(array = [], key = 'id') {
  return array.reduce((object, item) => ({ ...object, [item[key]]: item }), {})
}

export function sortBy(array, key, dir = 'desc') {
  return array.concat().sort((a, b) => {
    const [key1, key2] = key.split('.')
    let value1 = (key2 ? a[key1][key2] : a[key1]) || (dir === 'desc' ? '' : 'zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz')
    let value2 = (key2 ? b[key1][key2] : b[key1]) || (dir === 'desc' ? '' : 'zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz')
    if (typeof value1 === 'string' && typeof value2 === 'string') {
      value1 = value1.toLowerCase()
      value2 = value2.toLowerCase()
    }
    if (typeof value1 === 'undefined' && typeof value2 !== 'undefined') {
      return
    }
    return value1 > value2 ? (dir === 'desc' ? -1 : 1) : value1 < value2 ? (dir === 'desc' ? 1 : -1) : 0
  })
}

export function setNext(variable, array = []) {
  const index = array.indexOf(variable)
  if (index === -1 || index === array.length - 1) {
    variable = array[0]
  } else {
    variable = array[index + 1]
  }
}
